import { ArrowLeft } from "lucide-react";
import { ORG } from "@/config/site";

const SECTIONS = [
  {
    title: "The Service",
    body: "This website and its connected SMS program are operated by The BOURGANIZATION Institute, NGO (BGNZN). They provide cooperative membership information, a private clearing ledger, and — for enrolled members — the ability to move 100% cash-backed $sUSD settlement balances by text message.",
  },
  {
    title: "SMS Program Terms",
    body: "By enrolling in the SMS ledger program you agree to receive transactional text messages (payment confirmations and ledger alerts) from the Institute at the mobile number you provide. Message frequency varies with your activity. Message and data rates may apply according to your mobile plan. Reply STOP to any message to opt out immediately; reply HELP for assistance. Consent to receive texts is not a condition of membership or of any purchase.",
  },
  {
    title: "Supported Carriers & Liability",
    body: "The program works on major US carriers. Carriers are not liable for delayed or undelivered messages. Delivery is subject to carrier filtering and your device remaining in service.",
  },
  {
    title: "Ledger Terms",
    body: "All clearing activity is governed by the Cooperative Membership Agreement signed at enrollment. Settlement is final at execution (T+0) with zero trailing interest. Demonstration balances shown to non-members carry no monetary value.",
  },
  {
    title: "Acceptable Use",
    body: "Payment commands are accepted only from enrolled, opted-in member devices. Attempting to spoof, probe, or interfere with the SMS webhook or portal endpoints is prohibited and logged. The Institute may suspend SMS access for misuse.",
  },
  {
    title: "Changes & Contact",
    body: "These terms may be updated on this page; continued use after an update constitutes acceptance. Contact the Institute through the WhatsApp membership channel in the site footer with any questions.",
  },
];

const Terms = () => (
  <div data-testid="terms-page" className="min-h-screen bg-stone-950 text-stone-200">
    <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
      <div className="space-y-4">
        <a href="/" data-testid="terms-back-link" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-stone-500 hover:text-amber-500 transition-colors">
          <ArrowLeft size={13} /> Return to the Institute
        </a>
        <span className="mono-tag text-xs uppercase tracking-widest text-amber-500 block">Legal</span>
        <h1 className="text-4xl font-bold tracking-tight text-stone-100 display-serif">Terms &amp; Conditions</h1>
        <p className="text-stone-500 text-xs uppercase tracking-widest">{ORG.name} · Effective October 2026</p>
      </div>
      {SECTIONS.map((s) => (
        <div key={s.title} className="space-y-2">
          <h2 className="text-base font-bold text-stone-100">{s.title}</h2>
          <p className="text-sm text-stone-400 leading-relaxed">{s.body}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Terms;
